import { API } from '../config';

export const getOrderFromTracking = (trackingNum) => {
    return fetch(`${API}/order-from-tracking/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({trackingNum})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

//verifyier user id used for auth
export const acceptVerify = (orderId, verifierUserId, userId, token) => {
    return fetch(`${API}/accept-verify/${verifierUserId}/${orderId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({userId})

    })
        .then(response => {
            return response.json()
        })
        .catch(err => console.log(err));
};

export const denyVerify = (orderId, verifierUserId, userId, token) => {
    return fetch(`${API}/deny-verify/${verifierUserId}/${orderId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({userId})
    })
        .then(response => {
            return response.json()
        })
        .catch(err => console.log(err));
};
